import { useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import size from "lodash/size";
import isEmpty from "lodash/isEmpty";
import {
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import ContextMenuItem from "./ContextMenuItem";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useNavigate } from "react-router";
import WhiteLogoImg from "../../assets/logo/white_logo.png";
import { setShowModal } from "../../actions/map";
import {
  clearAuthentication,
  isLoggedIn,
} from "../../v2_actions/auth";
import { getUserFirstName } from "../../actions/user";
import { CUSTOM_VALUE_NUM_TROLLEY_PHOTOGRAPHS, setCustomValue } from "../../v2_actions/custom_value"
import {
  itemFirstPart, itemSecondPart, itemThirdPart, itemFirstPartEventAndAlbum,
  itemSecondPartEventAndAlbum, itemThirdPartEventAndAlbum, itemFirstPartPhotographer,
  itemSecondPartPhotographer, itemThirdPartPhotographer, itemFirstPartPurchased,
  itemSecondPartPurchased, itemThirdPartPurchased
} from "../../routes";

const useStyles = makeStyles(() => ({
  name: {
    color: "white",
  },
  menutext: {
    color: "white",
  },
  mobileDrawer: {
    width: 250,
    background:
      "linear-gradient(to right, rgb(0, 45, 113) 0%, rgb(106, 157, 234) 100%)",
    color: "white",
  },
  desktopDrawer: {
    width: 300,
    height: "100%",
    background: "white",
    color: "#0c59cf",
    border: "2px solid #0c59cf",
    borderTop: "none",
  },
  iconbtn: {
    width: 25,
    height: 25,
    color: "#0c59cf",
  },
  logo: {
    fontFamily: "Aguafina Script",
    fontSize: 40,
    fontWeight: "400",
    color: "#0c59cf",
    textAlign: "center",
  },
  mobileLogo: {
    padding: 20,
    fontFamily: "Aguafina Script",
    fontSize: 40,
    fontWeight: "400",
    color: "white",
    textAlign: "center",
  },
  name: {
    paddingLeft: 15,
    paddingRight: 20,
  },
}));

export const ContextMenu = ({ showContextMenu, setShowContextMenu }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const authId = localStorage.getItem("auth_id");
  const auth_email = localStorage.getItem("auth_email");
  const is_staff = localStorage.getItem("is_staff");
  const authName = localStorage.getItem("auth_name");
  const sidebarRef = useRef(null);
  const isUserLoggedIn = useSelector((state) => isLoggedIn(state))
  const loggedInUserDisplayName = useSelector((state) => getUserFirstName(state))
  const { gallery_event_name, album_name, photographerNickName } = useParams();
  const isEventOrAlbumPage = (gallery_event_name || album_name)
  const isPhotographerPage = (photographerNickName && true)
  const isPurchasedPage = location.pathname === '/customer/purchased'

  const logOut = () => {
    dispatch(setShowModal(true));
    setShowContextMenu(false);
    dispatch(clearAuthentication());
    dispatch(setCustomValue({ name: CUSTOM_VALUE_NUM_TROLLEY_PHOTOGRAPHS, value: 0 }))
    navigate(`/customer/map`);
  };

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowContextMenu(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  useOutsideAlerter(sidebarRef);

  const renderFirstPart = () => {
    const firstPart = isEventOrAlbumPage ? itemFirstPartEventAndAlbum :
                      isPhotographerPage ? itemFirstPartPhotographer :
                      isPurchasedPage ? itemFirstPartPurchased : itemFirstPart
    return (
      <Box p={1}>
        <List>
          {firstPart.map((item) => (
            <ContextMenuItem
              className={classes.menutext}
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
              onClick={() => setShowContextMenu(false)}
            />
          ))}
        </List>
      </Box>
    )
  }

  const renderSecondPart = () => {
    const secondPart = isEventOrAlbumPage ? itemSecondPartEventAndAlbum :
                       isPhotographerPage ? itemSecondPartPhotographer :
                       isPurchasedPage ? itemSecondPartPurchased : itemSecondPart
    return (
      <Box p={1}>
        <List>
          {secondPart.map((item) => (
            <ContextMenuItem
              className={classes.menutext}
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
              onClick={() => setShowContextMenu(false)}
              openInNewBrowserTab={item.openInNewBrowserTab}
              openAsWindowLocation={item.openAsWindowLocation}
            />
          ))}
        </List>
      </Box>
    )
  }

  const renderThirdPart = () => {
    const thirdPart = isEventOrAlbumPage ? itemThirdPartEventAndAlbum :
                      isPhotographerPage ? itemThirdPartPhotographer :
                      isPurchasedPage ? itemThirdPartPurchased : itemThirdPart
    return (
      <Box p={1}>
        <List>
          {thirdPart.map((item) => (
            <ContextMenuItem
              className={classes.menutext}
              href={item.href}
              key={item.title}
              title={item.title}
              onClick={() => setShowContextMenu(false)}
              openInNewBrowserTab={item.openInNewBrowserTab}
              openAsWindowLocation={item.openAsWindowLocation}
            />
          ))}
        </List>
      </Box>
    )
  }

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box
        display="flex"
        flexDirection="column"
        style={{ cursor: "pointer", paddingRight: 0 }}>
        {isUserLoggedIn && (
          <>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between">
              <Box
                display="flex"
                alignItems="center"
                style={{ paddingLeft: 20 }}>
                <AccountCircleIcon
                  className={classes.iconbtn}
                  style={{ color: "white" }}
                />
                <Typography className={classes.name} variant="h6">
                  {loggedInUserDisplayName}
                </Typography>
              </Box>
          <IconButton onClick={() => setShowContextMenu(false)}>
            <ArrowBackIosIcon
              className={classes.iconbtn}
              style={{ color: "white" }}
            />
          </IconButton>
            </Box>
          <Typography
            variant="body2"
            style={{ marginLeft: 60 }}
            onClick={logOut}>
            Sign Out
          </Typography>
          </>
        )}
        {isUserLoggedIn === false && (
          <Box display="flex" alignItems="center" justifyContent="flex-end">
            <IconButton onClick={() => setShowContextMenu(false)}>
              <ArrowBackIosIcon
                className={classes.iconbtn}
                style={{ color: "white" }}
              />
            </IconButton>
          </Box>
        )}
      </Box>
      {authId && is_staff === "false" && (
        <Divider style={{ backgroundColor: "white" }} />
      )}
      { renderFirstPart() }
      <Divider style={{ backgroundColor: "white" }} />
      { renderSecondPart() }
      <Divider style={{ backgroundColor: "white" }} />
      { renderThirdPart() }
    </Box>
  );

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.mobileDrawer }}
      variant="temporary"
      open={showContextMenu}>
      <div ref={sidebarRef}>{content}</div>
    </Drawer>
  );
};

export default ContextMenu;
